import { useContext, useRef } from "react";
import AiChatBody from "../AiChatBody/AiChatBody";
import AiInputBox from "../AiInputBox/AiInputBox";
import styles from "./AiBody.module.css";
import { UserDetailsContext } from "../../../../UserDetailsContext";
import { promptMaxChars } from "../../utils/utils";
import { useMixPanelForTracking } from "../../../../Shared_utilities/trackmixpanel";
import { useEffect } from "react";

const suggestionList = [
  "Give me a leaderboard of L1 bids per auction.",
  "What transporter has the largest owned fleet?",
  "What transporter has won the most business?",
];

function generateId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export default function AiBody({
  chatHistory,
  allowedPrompts,
  sendPrompt,
  resetChat,
  setChatHistory,
  setReplyTo,
  replyTo,
}) {
  const [userDetails] = useContext(UserDetailsContext);

  const inputRef = useRef(null);

  const {TrackMixPanel} = useMixPanelForTracking()

  const handleSuggestionClick = (suggestion) => {
    if (!suggestion.trim()) return;
    handleSend(suggestion);
  };

  const handleSend = (text = "") => {
    const trimmed = text.trim();
    if (!trimmed) return;

    if (trimmed.length > promptMaxChars) {
      const errorEntry = {
        id: generateId(),
        timestamp: Date.now(),
        prompt: trimmed,
        response: `Your message exceeds the maximum limit of ${promptMaxChars} characters.`,
        isError: true,
      };
      setChatHistory((prev) => [...prev, errorEntry]);
      return;
    }

    sendPrompt(trimmed);
  };

  useEffect(()=>{
    TrackMixPanel({
      "ModuleName":"lorri ai",
      "ScreenName":"chat",
      "Definition":"the user has opened lorri intelligence chat."
    })
  },[])

  return (
    <div className={styles.aiBodyGrid}>
      <AiChatBody
        allowedPrompts={allowedPrompts}
        chatHistory={chatHistory}
        greeting={`Hello ${
          userDetails?.user_details?.name || "there"
        }! How can I assist you today?`}
        suggestions={suggestionList}
        handleSuggestionClick={handleSuggestionClick}
        replyTo={replyTo}
        setReplyTo={setReplyTo}
        inputRef={inputRef}
      />

      <AiInputBox
        allowedPrompts={allowedPrompts}
        handleSend={handleSend}
        resetChat={resetChat}
        replyTo={replyTo}
        setReplyTo={setReplyTo}
        inputRef={inputRef}
      />
    </div>
  );
}
